import { useFlags } from '@project44/feature-flags';
import { CSS, Typography } from '@project44/manifest-ds';
import { DateFormat, formatDateTime } from '@project44/ui-utils';

import DateTimeWindow from '../DateTimeWindow';

interface PlannedDateProps {
  css?: CSS;
  dateTime?: string; // Deprecated
  displayTimezoneAbbreviation?: boolean;
  initialDateTime?: string;
  lastPlannedDateTime?: string;
  plannedEndDate?: string; // Future, see https://project44.atlassian.net/browse/VOC-1463
  plannedStartDate?: string;
  timeZone?: string;
}

export const PlannedDate = ({
  css,
  dateTime = '',
  displayTimezoneAbbreviation,
  initialDateTime = '',
  lastPlannedDateTime = '',
  plannedEndDate,
  plannedStartDate,
  timeZone,
}: PlannedDateProps) => {
  const { featureVoc1463, featureVoc1496 } = useFlags();

  return (
    <Typography variant="subtext" data-testid="planned-date" css={css}>
      {featureVoc1463 && plannedStartDate ? (
        <DateTimeWindow
          displayTimezoneAbbreviation={displayTimezoneAbbreviation}
          endDateTime={plannedEndDate}
          initialDateTime={initialDateTime}
          lastPlannedDateTime={lastPlannedDateTime}
          startDateTime={plannedStartDate}
          timeZone={timeZone}
        />
      ) : (
        formatDateTime({
          dateTime: featureVoc1496 ? initialDateTime : dateTime,
          dateFormat: DateFormat.monthDayYearHourMinute,
        }) || '-'
      )}
    </Typography>
  );
};

export default PlannedDate;
